import { styled } from '@linaria/react'
import { Button } from '../Button'

export const PrimaryLoginButtonSC = styled(Button)``
